import { render, staticRenderFns } from "./gastos.vue?vue&type=template&id=166bebb3&scoped=true"
import script from "./gastos.vue?vue&type=script&lang=js"
export * from "./gastos.vue?vue&type=script&lang=js"
import style0 from "./gastos.vue?vue&type=style&index=0&id=166bebb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166bebb3",
  null
  
)

export default component.exports